import React, { Fragment } from "react";
import { Typography, Box, Button, Link, Grid } from "@material-ui/core";
import { useStyles } from "../Theme.js";

const Decouvrir = () => {
  const classes = useStyles();
  return (
    <Fragment>
      <Box
        className={classes.subHeader}
        style={{
          marginTop: 20,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          paddingTop: "0",
          boxSizing: "border-box",
        }}
      >
        <Typography
          variant="h3"
          className={classes.subHeaderTitle}
          style={{ textAlign: "center", display: "block" }}
        >
          Découvrir le projet
        </Typography>
      </Box>
      <Box
        style={{
          padding: "0 15px",
          boxSizing: "border-box",
          width: "calc(100% - 15px)",
          margin: "auto",
          fontSize: "13px",
        }}
      >
        <p>
          L’ambition, avec cette application, est de contribuer à l’amélioration
          de l’observation du tourisme sur les territoires. L’objet est de
          recueillir des ressentis partagés par les usagers – qu’ils soient
          professionnels, habitants, touristes ou élus – à un endroit précis et
          à un instant donné. Cela devrait permettre de cibler des forces ou des
          difficultés sur le territoire, et d’identifier des points de
          convergence ou de désaccord entre ces quatre catégories d’usagers.
        </p>
        <p>
          L’application est une composante d’un dispositif plus global :
          l’Observatoire NATTUR. Alimenté par les données issues de
          l’application, de sources open data, et de bases de données partagées
          par les institutions, l’Observatoire NATTUR vise à croiser des données
          localisées, datées, qualitatives et quantitatives, mises à jour
          régulièrement, afin de fournir une lecture la plus complète possible
          de l’activité touristique et de ses effets sur les territoires
          (retombées économiques, impacts sociaux ou environnementaux…).
        </p>
        <p>
          L’application et l’Observatoire NATTUR ont été développés dans le
          cadre d’un projet transfrontalier Interreg POCTEFA
          (France-Espagne-Andorre) conduit entre 2018 et 2022, cofinancé à
          hauteur de 65% par le Fonds Européen de Développement Régional
          (FEDER).
        </p>
      </Box>
      <Grid item xs={12} style={{ display: "flex", alignItems: "flex-start" }}>
        <a
          href="https://ta2d.univ-tlse2.fr/observe_nattur/observatoire_nattur.html"
          target="_blank"
          className={classes.gridLink}
          style={{ justifyContent: "center", marginBottom: "3vh" }}
          rel="noreferrer"
        >
          <Button className={classes.navButton}>Observatoire</Button>
        </a>

        <a
          href="https://www.nattur.eu"
          target="_blank"
          className={classes.gridLink}
          style={{ justifyContent: "center", marginBottom: "3vh" }}
          rel="noreferrer"
        >
          <Button className={classes.navButton}>Projet Nattur</Button>
        </a>
      </Grid>
    </Fragment>
  );
};

export default Decouvrir;
